import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getLocalityList = (formData, showLoader = true) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_LOCALITY_LIST_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/locality/list`,
        formData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_LOCALITY_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_LOCALITY_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({ type: "GET_LOCALITY_LIST_FAILED", payload: error.message });
    } finally {
      if (showLoader) {
        dispatch({ type: "STOP_LOADING" });
      }
    }
  };
};

export const addLocality = (formData, showLoader = true) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "ADD_LOCALITY_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const {data} = await axios.post(
        `${BASE_URL}/locality/add`,
        formData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "ADD_LOCALITY_SUCCESS", payload: data });
        return data;
    } else {
        dispatch({ type: "ADD_LOCALITY_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({ type: "ADD_LOCALITY_FAILED", payload: error });
    } finally {
      if (showLoader) {
        dispatch({ type: "STOP_LOADING" });
      }
    }
  };
};

export const viewLocality = (id, showLoader = true) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_LOCALITY_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.get(
        `${BASE_URL}/locality/view/${id}`,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_LOCALITY_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_LOCALITY_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({ type: "GET_LOCALITY_FAIL", payload: error.message });
    } finally {
      if (showLoader) {
        dispatch({ type: "STOP_LOADING" });
      }
    }
  };
};

export const updateLocality = (id, formData, showLoader = true) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "UPDATE_LOCALITY_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.put(
        `${BASE_URL}/locality/update/${id}`,
        formData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_LOCALITY_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "UPDATE_LOCALITY_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({ type: "UPDATE_LOCALITY_FAILED", payload: error.message });
    } finally {
      if (showLoader) {
        dispatch({ type: "STOP_LOADING" });
      }
    }
  };
};

export const deleteLocality = (id, showLoader = true) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "DELETE_LOCALITY_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.delete(
        `${BASE_URL}/locality/delete/${id}`,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "DELETE_LOCALITY_SUCCESS", payload: data });
      } else {
        dispatch({ type: "DELETE_LOCALITY_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({ type: "DELETE_LOCALITY_FAILED", payload: error.message });
    } finally {
      if (showLoader) {
        dispatch({ type: "STOP_LOADING" });
      }
    }
  };
};
